import { createAction, props } from '@ngrx/store';
import { Commodity } from '../_models';

// Action types
export const loadCommodities = createAction('[Commodity] Load Commodities');
export const loadCommoditiesSuccess = createAction(
  '[Commodity] Load Commodities Success',
  props<{ commodities: Commodity[] }>()
);
export const loadCommoditiesFailure = createAction(
  '[Commodity] Load Commodities Failure',
  props<{ error: any }>()
);

export const addCommodity = createAction(
  '[Commodity] Add Commodity',
  props<{ commodity: Commodity }>()
);
export const addCommoditySuccess = createAction(
  '[Commodity] Add Commodity Success',
  props<{ commodity: Commodity }>()
);
export const addCommodityFailure = createAction(
  '[Commodity] Add Commodity Failure',
  props<{ error: any }>()
);

export const updateCommodity = createAction(
  '[Commodity] Update Commodity',
  props<{ commodity: Commodity }>()
);
export const updateCommoditySuccess = createAction(
  '[Commodity] Update Commodity Success',
  props<{ commodity: Commodity }>()
);
export const updateCommodityFailure = createAction(
  '[Commodity] Update Commodity Failure',
  props<{ error: any }>()
);

export const deleteCommodity = createAction(
  '[Commodity] Delete Commodity',
  props<{ id: number }>()
);
export const deleteCommoditySuccess = createAction(
  '[Commodity] Delete Commodity Success',
  props<{ id: number }>()
);
export const deleteCommodityFailure = createAction(
  '[Commodity] Delete Commodity Failure',
  props<{ error: any }>()
);
